var React = require('react');

function MailSharp (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Mail"),React.createElement("path",{"d":"M464 80H48a16 16 0 00-16 16v320a16 16 0 0016 16h416a16 16 0 0016-16V96a16 16 0 00-16-16zM265.82 284.63a16 16 0 01-19.64 0L89.55 162.81l19.64-25.26L256 251.73l146.81-114.18 19.64 25.26z","key":1})]);
}

MailSharp.defaultProps = {"className":"ionicon","viewBox":"0 0 512 512"};

module.exports = MailSharp;

MailSharp.default = MailSharp;
